import { render, staticRenderFns } from "./EditPickupGroups.vue?vue&type=template&id=2ca43f60&"
import script from "./EditPickupGroups.vue?vue&type=script&lang=js&"
export * from "./EditPickupGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports